module.exports = __webpack_public_path__ + "img/slide12.2ab521a6.png";